export interface NotificationPayload {
  pinboard_id?: number;
  pinboard_name?: string;
  artifact_id?: number;
  /** The shared artifact's readout -- used to deep-link when shared_artifact_id is missing. */
  readout_id?: number | null;
  artifact_name?: string;
  artifact_type?: string;
  /** Sent by the share flow alongside shared_artifact_id; may be null. */
  shared_artifact_id?: number;
  shared_pinboard_id?: number;
  board_id?: number;
  board_name?: string;
  title?: string | null;
  description?: string | null;
  /** system_alert carries its text here instead of a named resource. */
  message?: string | null;
}

export interface NotificationRecord {
  id: number;
  /** Present on websocket frames only -- the list endpoint omits it. */
  recipient_user_email?: string;
  /** Null for server-generated notifications such as system_alert. */
  sender_user_email?: string | null;
  sender_username?: string | null;
  project_id?: string;
  notification_type: string;
  payload: NotificationPayload;
  is_read: boolean;
  created_at: string;
  /** Present on the list endpoint only -- websocket frames omit it. */
  read_at?: string | null;
}

export interface NotificationsResult {
  unread_count: number;
  notifications: NotificationRecord[];
}

/** Standard HQI envelope. error/status live alongside the payload. */
export interface NotificationsApiResponse {
  error: boolean;
  message: string;
  response: NotificationsResult;
  status: number;
  queue_status?: boolean;
  show_response?: boolean;
  service_id?: string;
  version?: string;
}

export interface MarkReadResult {
  updated_count: number;
}

export const NOTIFICATIONS_PAGE_SIZE = 20;

export const NOTIFICATION_TYPE_SYSTEM_ALERT = 'system_alert';
